<template>
  <div class="p-grid dashboard">
    <div class="p-col-12">
      <Toast />

      <div class="card">
        <DataTable
          :value="items"
          :paginator="true"
          class="p-datatable-outlets responsive-datatable"
          :rows="10"
          data-key="doc_number"
          :filters="filters1"
          :loading="loading1"
          :totalRecords="total_records"
          @page="getListWarehouse($event)"
          aria-label="Daftar Retur Barang"
          role="table"
        >
          <div class="page-title">
            <i
              class="pi pi-box"
              style="font-size: 1.5rem; color: #607d8b; margin-right: 0.5rem"
            ></i>
            <span class="main-title">Daftar Retur Barang</span>
            <span class="subtitle"
              >Kelola dan review semua data retur barang</span
            >
          </div>
          <template #header>
            <div
              class="table-header responsive-filter compact-filter filter-2row"
            >
              <div class="filter-row filter-row-inputs">
                <span class="p-input-icon-left filter-item">
                  <i class="pi pi-search" />
                  <InputText
                    v-model="filters1['doc_number']"
                    placeholder="Cari Nomor Bon"
                    aria-label="Cari Nomor Bon"
                  />
                </span>
                <span class="p-input-icon-left filter-item">
                  <i class="pi pi-search" />
                  <InputText
                    v-model="filters1['doc_date']"
                    placeholder="Cari Tanggal Bon"
                    aria-label="Cari Tanggal Bon"
                  />
                </span>
                <Dropdown
                  v-model="selectType"
                  :options="type"
                  optionLabel="type"
                  placeholder="Pilih Tipe"
                  class="filter-item"
                  aria-label="Pilih Tipe"
                />
                <Dropdown
                  v-model="selectStatus"
                  :options="status"
                  optionLabel="label"
                  placeholder="Pilih Status"
                  class="filter-item"
                  aria-label="Pilih Status"
                />
                <div v-if="loading.upload == false" class="filter-item">
                  <FileUpload
                    @uploader="onUpload"
                    :customUpload="true"
                    mode="basic"
                    :disabled="loading.upload"
                    accept=".csv"
                    label="Import"
                    chooseLabel="Import"
                    class="p-mr-2 p-d-inline-block filter-upload-align"
                    aria-label="Import CSV"
                  />
                </div>
              </div>
              <div class="filter-row filter-row-actions">
                <Button
                  label="Search"
                  icon="pi pi-search"
                  class="p-button-primary filter-item"
                  style="height: 35px"
                  aria-label="Search"
                  @click="onSearch"
                />
                <Button
                  label="Reset"
                  icon="pi pi-refresh"
                  @click="clearFilters"
                  class="p-button-danger filter-item"
                  style="height: 35px"
                  aria-label="Reset"
                />
                <div v-if="loading.upload == true" class="filter-item">
                  <button
                    type="submit"
                    class="btn btn-primary filter-item"
                    :disabled="true"
                    aria-label="Uploading"
                  >
                    Uploading...
                    <span>
                      <i
                        class="pi pi-spin pi-spinner"
                        style="font-size: 12px"
                      ></i>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </template>
          <template #empty>Data tidak tersedia.</template>
          <template #loading>Sedang mengambil data. Mohon tunggu.</template>
          <Column
            field="doc_number"
            header="Nomor Bon"
            :headerStyle="{ minWidth: '160px', width: '160px' }"
            columnClass="nomor-bon-col"
          >
            <template #body="slotProps">
              <span :aria-label="'Nomor Bon: ' + slotProps.data.doc_number">{{
                slotProps.data.doc_number
              }}</span>
            </template>
          </Column>
          <Column
            field="doc_date"
            header="Tanggal Bon"
            :headerStyle="{ minWidth: '120px', width: '120px' }"
            columnClass="tanggal-bon-col"
          >
            <template #body="slotProps">
              <span :aria-label="'Tanggal Bon: ' + slotProps.data.doc_date">{{
                slotProps.data.doc_date
              }}</span>
            </template>
          </Column>
          <Column
            header="Total Barang"
            :headerStyle="{ minWidth: '100px', width: '100px' }"
            class="hide-mobile"
            columnClass="total-barang-col"
          >
            <template #body="slotProps">
              <span
                :aria-label="'Total Barang: ' + slotProps.data.total_item"
                >{{ slotProps.data.total_item }}</span
              >
            </template>
          </Column>
          <Column
            header="Total Harga"
            :headerStyle="{ minWidth: '140px', width: '140px' }"
            class="hide-mobile"
            columnClass="total-harga-col"
          >
            <template #body="slotProps">
              <span
                :aria-label="'Total Harga: ' + slotProps.data.total_price"
                >{{ slotProps.data.total_price | currency }}</span
              >
            </template>
          </Column>
          <Column
            header="Status"
            :headerStyle="{ minWidth: '110px', width: '110px' }"
            columnClass="status-col"
          >
            <template #body="slotProps">
              <div v-if="slotProps.data.status == 1">
                <span
                  style="color: green; font-weight: bold"
                  aria-label="Status: Confirmed"
                  >Confirmed</span
                >
              </div>
              <div v-else-if="slotProps.data.status == 2">
                <span
                  style="color: blue; font-weight: bold"
                  aria-label="Status: Ditolak"
                  >Ditolak</span
                >
              </div>
              <div v-else>
                <span
                  style="color: red; font-weight: bold"
                  aria-label="Status: Pending"
                  >Pending</span
                >
              </div>
            </template>
          </Column>
          <Column
            header="Tipe"
            :headerStyle="{ minWidth: '140px', width: '140px' }"
            class="hide-mobile"
            columnClass="tipe-col"
          >
            <template #body="slotProps">
              <span :aria-label="'Tipe: ' + slotProps.data.type">{{
                slotProps.data.type
              }}</span>
            </template>
          </Column>
          <Column
            :header="'Aksi'"
            headerStyle="width: 110px; min-width: 110px;"
            bodyStyle="text-align: center; overflow: visible"
            columnClass="aksi-col"
          >
            <template #body="slotProps">
              <div class="action-buttons">
                <router-link
                  :to="{
                    name: 'receiving-warehouse-detail',
                    query: { doc_number: slotProps.data.doc_number }
                  }"
                >
                  <Button
                    type="button"
                    icon="pi pi-eye"
                    class="p-button-rounded p-mr-2 action-btn"
                    v-tooltip.top="'Lihat Detail'"
                    aria-label="Lihat Detail"
                  ></Button>
                </router-link>
              </div>
            </template>
          </Column>
        </DataTable>

        <Dialog
          :visible.sync="deleteDialog"
          :style="{ width: '450px' }"
          header="Confirm"
          :modal="true"
        >
          <div class="confirmation-content">
            <i
              class="pi pi-exclamation-triangle p-mr-3"
              style="font-size: 2rem"
            />
            <span v-if="outletInbound">
              Apakah kamu yakin ingin menghapus
              <b>{{ outletInbound.doc_number }}</b
              >?
            </span>
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              class="p-button-text"
              @click="deleteDialog = false"
            />
            <Button
              label="Yes"
              icon="pi pi-check"
              class="p-button-text"
              @click="deleteOutletInbound(outletInbound.doc_number)"
            />
          </template>
        </Dialog>
        <Dialog
          :visible.sync="activeDialog"
          :style="{ width: '450px' }"
          header="Confirm"
          :modal="true"
        >
          <div class="confirmation-content">
            <i
              class="pi pi-exclamation-triangle p-mr-3"
              style="font-size: 2rem"
            />
            <span v-if="outletInbound">
              Apakah kamu yakin ingin meng-aktifkan
              <b>{{ outletInbound.doc_number }}</b
              >?
            </span>
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              class="p-button-text"
              @click="activeDialog = false"
            />
            <Button
              label="Yes"
              icon="pi pi-check"
              class="p-button-text"
              @click="activeOutletInbound(outletInbound.doc_number)"
            />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

let moment = require('moment')
export default {
  data() {
    return {
      moment: moment,
      filters1: {},
      doc_number: '',
      selectType: null,
      selectStatus: null,
      loading1: true,
      expandedRows: [],
      items: null,
      deleteDialog: false,
      activeDialog: false,
      total_records: null,
      outletInbound: {},
      loading: {
        deleteButton: false,
        activeButton: false,
        upload: false
      },
      type: [{ type: 'RETURN' }, { type: 'TRANSFER ITEM' }],
      status: [
        { value: 0, label: 'PENDING' },
        { value: 1, label: 'CONFIRMED' }
      ]
    }
  },
  computed: {
    ...mapState(['user', 'isAuthenticated']),
    $isMobile() {
      return window.innerWidth <= 960
    }
  },

  mounted() {
    this.getListWarehouse()
  },
  methods: {
    onSearch() {
      this.getListWarehouse()
    },
    clearFilters() {
      this.selectType = null
      this.selectStatus = null
      this.getListWarehouse()
    },
    onUpload(event) {
      this.loading.upload = true
      let formData = new FormData()
      formData.set('file', event.files[0])

      this.$http
        .post(
          `${process.env.VUE_APP_API_URL}/dashboard/warehouse-inbound/csv`,
          formData
        )
        .then(response => {
          this.loading.upload = false
          if (response.status == 200) {
            this.doc_number = response.data.data.doc_number
            this.$toast.add({
              severity: 'success',
              summary: 'Success',
              detail: 'File Uploaded',
              life: 3000
            })
            setTimeout(() => {
              this.$router.push({
                name: 'receiving-warehouse-detail',
                query: { doc_number: this.doc_number }
              })
            }, 1000)
            setTimeout(!this.loading.upload, 10000)
          } else {
            setTimeout(!this.loading, 10000)
            this.$toast.add({
              severity: 'error',
              summary: 'Failed',
              detail: 'File Uploaded',
              life: 3000
            })
          }
        })
    },
    onUploadSisgud(event) {
      this.loading.upload = true
      let formData = new FormData()
      formData.set('file', event.files[0])

      this.$http
        .post(
          `${process.env.VUE_APP_API_URL}/dashboard/outlet-inbounds/csv/sisgud`,
          formData
        )
        .then(response => {
          this.loading.upload = false
          if (response.status == 200) {
            this.doc_number = response.data.data.doc_number
            this.$toast.add({
              severity: 'success',
              summary: 'Success',
              detail: 'File Uploaded',
              life: 3000
            })
            setTimeout(
              this.$router.push({
                name: 'receiving-detail',
                query: { doc_number: this.doc_number }
              }),
              10000
            )
            setTimeout(!this.loading.upload, 10000)
          } else {
            setTimeout(!this.loading, 10000)
            this.$toast.add({
              severity: 'error',
              summary: 'Failed',
              detail: 'File Uploaded',
              life: 3000
            })
          }
        })
    },
    getListWarehouse(event) {
      this.loading1 = true
      let page = 1
      if (event) {
        page = event.page + 1
      }

      let url = `${process.env.VUE_APP_API_URL}/dashboard/warehouse-inbounds?page=${page}&`
      let params = []

      if (this.selectType) {
        params.push(`type=${encodeURIComponent(this.selectType.type)}`)
      }

      if (this.selectStatus !== null) {
        params.push(`status=${encodeURIComponent(this.selectStatus.value)}`)
      }

      if (params.length) {
        url += `${params.join('&')}`
      }

      this.$http.get(url).then(response => {
        this.loading1 = false
        if (response.status === 200) {
          this.items = response.data.data.warehouse_inbounds
          this.total_records = response.data.data.total_item
        } else {
          console.error('Failed to get warehouse inbounds')
        }
      })
    },
    confirmDelete(outletInbound) {
      this.outletInbound = outletInbound
      this.deleteDialog = true
    },
    confirmActive(outletInbound) {
      this.outletInbound = outletInbound
      this.activeDialog = true
    },
    deleteOutletInbound(doc_number) {
      this.loading.deleteButton = true
      this.$http
        .delete(
          `${process.env.VUE_APP_API_URL}/dashboard/outlet-inbounds?doc_number=${doc_number}`
        )
        .then(response => {
          this.loading.deleteButton = false
          this.deleteDialog = false
          if (response.status === 200) {
            this.$toast.add({
              severity: 'success',
              summary: 'Delete Success',
              detail: 'Data Deleted',
              life: 3000
            })
            this.getListWarehouse()
          } else if (response.status === 403) {
            this.$toast.add({
              severity: 'error',
              summary: 'Delete Not Permitted',
              detail: `Data Can't be Deleted`,
              life: 3000
            })
          } else {
            this.$toast.add({
              severity: 'error',
              summary: 'Delete Failed',
              detail: 'Data failed to Deleted',
              life: 3000
            })
            console.error('gagal delete')
          }
        })
    },
    activeOutletInbound(doc_number) {
      this.loading.activeButton = true
      this.$http
        .patch(
          `${process.env.VUE_APP_API_URL}/dashboard/outlet-inbounds?doc_number=${doc_number}`
        )
        .then(response => {
          this.loading.activeButton = false
          this.activeDialog = false
          if (response.status === 200) {
            this.$toast.add({
              severity: 'success',
              summary: 'Change status success',
              detail: 'Congrats, those status has been changed',
              life: 3000
            })
            this.getListWarehouse()
          } else {
            this.$toast.add({
              severity: 'error',
              summary: 'Change status failed',
              detail: 'Please try again',
              life: 3000
            })
            console.error('gagal merubah status')
          }
        })
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .p-progressbar {
  height: 0.5rem;
  background-color: #d8dadc;

  .p-progressbar-value {
    background-color: #607d8b;
  }
}

.p-datatable .p-column-filter {
  display: none;
}

.table-header {
  display: flex;
  justify-content: space-between;
}

/deep/ .p-datatable.p-datatable-outlets {
  .p-datatable-header {
    padding: 1rem;
    text-align: left;
    font-size: 1.5rem;
  }

  .p-paginator {
    padding: 1rem;
  }

  .p-datatable-thead > tr > th {
    text-align: left;
  }

  .p-datatable-tbody > tr > td {
    cursor: auto;
  }

  .p-dropdown-label:not(.p-placeholder) {
    text-transform: uppercase;
  }
}

/* Responsive */
.p-datatable-outlets .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

.customer-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-qualified {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-unqualified {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-negotiation {
    background: #feedaf;
    color: #8a5340;
  }

  &.status-new {
    background: #b3e5fc;
    color: #23547b;
  }

  &.status-renewal {
    background: #eccfff;
    color: #694382;
  }

  &.status-proposal {
    background: #ffd8b2;
    color: #805b36;
  }
}

.p-progressbar-value.ui-widget-header {
  background: #607d8b;
}

@media (max-width: 640px) {
  .p-progressbar {
    margin-top: 0.5rem;
  }
}

.product-image {
  width: 100px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.orders-subtable {
  padding: 1rem;
}

.product-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-instock {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-outofstock {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-lowstock {
    background: #feedaf;
    color: #8a5340;
  }
}

.order-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.order-delivered {
    background: #c8e6c9;
    color: #256029;
  }

  &.order-cancelled {
    background: #ffcdd2;
    color: #c63737;
  }

  &.order-pending {
    background: #feedaf;
    color: #8a5340;
  }

  &.order-returned {
    background: #eccfff;
    color: #694382;
  }
}

// DataTable responsiveness
.responsive-datatable {
  width: 100%;
  overflow-x: auto;
  .p-datatable-wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .p-datatable-table {
    min-width: 850px;
    width: 100%;
    table-layout: fixed;
  }
  th.nomor-bon-col,
  td.nomor-bon-col {
    min-width: 160px;
    width: 160px;
  }
  th.tanggal-bon-col,
  td.tanggal-bon-col {
    min-width: 120px;
    width: 120px;
  }
  th.total-barang-col,
  td.total-barang-col {
    min-width: 100px;
    width: 100px;
  }
  th.total-harga-col,
  td.total-harga-col {
    min-width: 140px;
    width: 140px;
  }
  th.status-col,
  td.status-col {
    min-width: 110px;
    width: 110px;
  }
  th.tipe-col,
  td.tipe-col {
    min-width: 140px;
    width: 140px;
  }
  th.aksi-col,
  td.aksi-col {
    min-width: 110px;
    width: 110px;
  }
  .hide-mobile {
    @media (max-width: 960px) {
      display: table-cell !important;
    }
  }
  .action-buttons {
    display: flex;
    gap: 0.5rem;
    justify-content: center;
    align-items: center;
    @media (max-width: 960px) {
      gap: 1rem;
    }
  }
}
.datatable-card-row {
  margin-bottom: 0.25rem;
}
.datatable-card {
  background: #f8f9fa;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  padding: 1rem;
  margin-bottom: 1rem;
  font-size: 1rem;
}
@media (max-width: 960px) {
  .p-datatable-thead,
  .p-datatable-tfoot {
    display: none !important;
  }
  .datatable-card-row strong {
    min-width: 120px;
    display: inline-block;
  }
  .action-btn {
    min-width: 40px;
    min-height: 40px;
    font-size: 1.2rem;
  }
}

// Improved page title
.page-title {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 1.5rem;
  .main-title {
    font-size: 1.6rem;
    font-weight: 700;
    color: #222;
    margin-bottom: 0.2rem;
  }
  .subtitle {
    font-size: 1rem;
    color: #607d8b;
    margin-bottom: 0.2rem;
  }
}

// Compact filter style
.compact-filter {
  padding: 0.5rem 0;
  .filter-group {
    flex-wrap: wrap;
    gap: 0.5rem;
    align-items: flex-end;
    margin-bottom: 0;
  }
  .filter-item {
    margin-bottom: 0;
    min-width: 120px;
  }
}

// 2-row filter layout
.filter-2row {
  display: flex;
  flex-direction: column;
  width: 100%;
  .filter-row {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-bottom: 1.5rem;
    align-items: flex-end;
  }
  .filter-row-inputs {
    margin-bottom: 0.5rem;
  }
  .filter-row-actions {
    margin-bottom: 0;
    justify-content: flex-start;
  }
}

// Add more space between table rows
.responsive-datatable .p-datatable-tbody > tr {
  height: 56px;
}

// For mobile, keep spacing consistent
@media (max-width: 768px) {
  .filter-2row {
    width: 100%;
    .filter-row {
      flex-direction: column;
      align-items: stretch;
      gap: 0.5rem;
      width: 100%;
      margin-bottom: 1.5rem;
    }
  }
  .responsive-datatable .p-datatable-tbody > tr {
    height: 64px;
  }
}

// Fix FileUpload alignment in filter row
.filter-upload-align {
  .p-button {
    height: 35px !important;
    padding: 0 1.25rem !important;
    display: flex;
    align-items: center;
    font-size: 1rem;
  }
  .p-fileupload-buttonbar {
    padding: 0 !important;
  }
  .p-fileupload-choose {
    height: 35px !important;
    display: flex;
    align-items: center;
    font-size: 1rem;
    padding: 0 1.25rem !important;
  }
  .p-fileupload {
    height: 35px !important;
    display: flex;
    align-items: center;
  }
}
.filter-item {
  height: 35px !important;
  display: flex;
  align-items: center;
}
</style>
